import { PortfolioAPI } from "@/api/portfolio";
import { queryClient } from "@/network/queryClient";
import { QueryKeys } from "@/network/queryKeys";
import { SchedulerCacheService } from "../scheduler/cache";
import { TasksCacheService } from "../tasks/cache";

export const PortfolioService = {
  async createPhoto(args, { taskRestPhotos = [] } = {}) {
    const { data } = await PortfolioAPI.createPortfolio(args);
    if (data.task) {
      const taskId = data.task;
      const newPhotos = taskRestPhotos.concat(data);
      queryClient.setQueryDataButKeepStale(
        [QueryKeys.bizTaskPhotos, taskId],
        newPhotos
      );
      const taskUpdates = { photos: newPhotos.map(({ _id }) => _id) };
      TasksCacheService.updateTask(taskId, taskUpdates);
      SchedulerCacheService.updateTask(taskId, taskUpdates);
    }
  },
  async removePhoto(photo, { taskId, taskRestPhotos = [] } = {}) {
    await PortfolioAPI.deleteById(photo._id);
    const task = photo.task || taskId;
    if (task) {
      const newPhotos = taskRestPhotos.filter(({ _id }) => _id !== photo._id);
      queryClient.setQueryDataButKeepStale(
        [QueryKeys.bizTaskPhotos, taskId],
        newPhotos
      );
      const taskUpdates = { photos: newPhotos.map(({ _id }) => _id) };
      TasksCacheService.updateTask(taskId, taskUpdates);
      SchedulerCacheService.updateTask(taskId, taskUpdates);
    }
  },
};
